import * as React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide';

import { CurrencyStyled } from './styled';

export interface ICurrencyProps extends IBasicStyledProps {
  isSpaced: boolean;
  isPrefix: boolean;
  content: string;
  children?: React.ReactNode;
}

const Currency = (props: ICurrencyProps) => (
  <CurrencyStyled data-testid="pd-currency" {...props} />
);

export default Currency;
